import { of, forkJoin } from 'rxjs';
import _get from 'lodash/get';
import { mergeMap, mapTo } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import commonDuck from 'ducks/common-duck';
import newBookingDuck from 'ducks/new-booking-duck';
import {
  isPaxSelector,
  selectedCitySelector,
  userCompanyIDSelector,
} from 'selectors/app-selector';
import {
  fetchPaxConfigurationAction,
  fetchUserConfigurationAction,
} from 'actions/app-actions';
import { isUsingPaxPersonalPayments } from 'helper/user';
import fetchObservableUtil from 'common/utils/fetch-observable';
import { getBookingConfigurationEndpoint } from 'actions/common-endpoints';
import { buildHeaders } from 'actions/fetch-helper';
import { buildCredentials } from '../../helper/session-helper';

const startGlobalLoadingEpic = action$ =>
  action$.pipe(
    ofType(newBookingDuck.types.REBOOK, newBookingDuck.types.REBOOK_WITH_CODES),
    mapTo(commonDuck.creators.startGlobalLoading()),
  );

const stopGlobalLoadingEpic = action$ =>
  action$.pipe(
    ofType(
      newBookingDuck.types.REBOOK_WITH_DETAIL,
      newBookingDuck.types.REBOOK_WITH_DETAILS,
      newBookingDuck.types.REBOOK_FAILED,
    ),
    mapTo(commonDuck.creators.stopGlobalLoading()),
  );

const fetchConfiguration = (action$, state$) =>
  action$.pipe(
    ofType(commonDuck.types.FETCH_CONFIGURATION),
    mergeMap(action => {
      const obs = [];
      const city = selectedCitySelector(state$.value);
      const latitude = _get(city, ['coordinates', 'latitude']);
      const longitude = _get(city, ['coordinates', 'longitude']);
      obs.push(
        fetchObservableUtil(
          getBookingConfigurationEndpoint(latitude, longitude),
          {
            method: 'GET',
            headers: buildHeaders(null, null, null, true),
            credentials: buildCredentials(),
          },
        ),
      );
      obs.push(of(action));
      return forkJoin(obs);
    }),
    mergeMap(([configuration, { countryCode, cityCode, cityID }]) => {
      const isPax = isPaxSelector(state$.value);
      const obs = [];

      obs.push(
        newBookingDuck.creators.setBookingConfiguration(
          _get(configuration, ['config']),
        ),
      );

      if (isPax) {
        const companyID = isUsingPaxPersonalPayments()
          ? undefined
          : userCompanyIDSelector(state$.value);
        obs.push(
          fetchPaxConfigurationAction(countryCode, cityCode, cityID, companyID),
        );
      } else {
        const companyID = userCompanyIDSelector(state$.value);
        obs.push(fetchUserConfigurationAction(companyID, cityCode, cityID));
      }
      return of(...obs);
    }),
  );

export default combineEpics(
  fetchConfiguration,
  startGlobalLoadingEpic,
  stopGlobalLoadingEpic,
);
